<template>
    <div class="splash-screen" :class="{ 'fade-out': isFading }" v-if="showSplash">
        <div class="logo-container">
            <img src="../assets/swift_logo_ai.png" alt="SwiftAI Logo">
            <div class="loading-bar">
                <div class="bar-fill"></div>
            </div>
        </div>
    </div>
    <div class="main-content" v-show="!showSplash">

      <iframe ref="gsaiIframe" sandbox="allow-scripts allow-popups allow-modals allow-forms allow-downloads allow-same-origin allow-popups-to-escape-sandbox allow-top-navigation allow-top-navigation-by-user-activation"
              :src="url" style="position: absolute; height: 100%; width:100%;top:0px; border: none">
      </iframe>

    </div>
</template>
<script>
import { Window } from '@progress/kendo-vue-dialogs';
import { Button } from '@progress/kendo-vue-buttons';
import { Input } from '@progress/kendo-vue-inputs';

export default {
    components: {
        'window': Window,
        'kbutton': Button,
        'kinput': Input
    },
    props: {
      url: String,
      azureId: String,
      userName: String
    },
    data: function () {
        return {
            showSplash: true,
            isFading: false
        };
    },
    async mounted() {
      const iframeEl = this.$refs.gsaiIframe;
      if (iframeEl) {
        // Use iframe.onload to ensure the iframe is ready to receive messages
        iframeEl.onload = async () => {
          // Wait for azureId and userName to be available (retry up to 10 times)
          // Check both prop and localStorage
          let azureId = this.azureId || localStorage.getItem('azure_id');
          let userName = this.userName || localStorage.getItem('user_name') || '';
          let maxRetries = 10;

          while ((!azureId || !userName) && maxRetries > 0) {
            await new Promise(resolve => setTimeout(resolve, 500));
            // Check both sources for azureId and userName
            azureId = this.azureId || localStorage.getItem('azure_id');
            userName = this.userName || localStorage.getItem('user_name') || '';
            maxRetries--;
            console.log(`[SwiftProcessingSPA] Waiting for user data (${10 - maxRetries}/10) - Azure ID: ${!!azureId}, User Name: ${!!userName}`);
          }

          if (!azureId) {
            console.error('[SwiftProcessingSPA] Failed to get azure_id after 10 retries');
            return;
          }

          if (!userName) {
            console.warn('[SwiftProcessingSPA] Warning: userName not available after 10 retries, proceeding anyway');
          }

          console.log(`[SwiftProcessingSPA] User data ready - Azure ID: ${azureId}, User Name: ${userName || 'not available'}`);

          // Wait longer for iframe to fully load and set up listeners
          await new Promise(resolve => setTimeout(resolve, 3000));

          // Dynamically get the target origin from the iframe's URL for security
          let targetOrigin;
          try {
            targetOrigin = new URL(this.url).origin;
          } catch (error) {
            console.error('[SwiftProcessingSPA] Invalid URL provided for iframe:', this.url, error);
            return;
          }

          // Send the message multiple times to ensure it's received (20 attempts)
          for (let i = 0; i < 20; i++) {
            if (iframeEl.contentWindow) {
              try {
                iframeEl.contentWindow.postMessage(
                  {
                    type: 'user_data',
                    azureId: azureId,
                    userName: userName,
                    parentURL: window.location.origin
                  },
                  targetOrigin
                );
                console.log(`[SwiftProcessingSPA] Sent user data to ${targetOrigin} (attempt ${i + 1}/20) - Azure ID: ${azureId}, User Name: ${userName || 'not available'}`);
              } catch (error) {
                console.warn(`[SwiftProcessingSPA] Failed to send message on attempt ${i + 1}:`, error);
              }
            }

            // Don't delay after the last attempt
            if (i < 19) {
              await new Promise(resolve => setTimeout(resolve, 500));
            }
          }
        };
      }

      setTimeout(() => {
        this.isFading = true
        setTimeout(() => {
          this.showSplash = false
        }, 1000) // match fade-out transition
      }, 2500) // initial splash duration
    },
    methods: {

    }
};

</script>
<style>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body,
html {
    height: 100%;
    font-family: Arial, sans-serif;
}

.splash-screen {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    transition: opacity 1s ease;
}

.splash-screen.fade-out {
    opacity: 0;
    pointer-events: none;
}

.splash-screen img {
    width: 400px;
    height: auto;
}


/* Loading Bar */
.loading-bar {
    width: 220px;
    height: 6px;
    background-color: #e0e0e0;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 0 5px #ffd85c88;
}

.bar-fill {
    height: 100%;
    width: 0%;
    background: linear-gradient(90deg, #f9c744, #ffdd80, #f9c744);
    animation: load 2s ease-in-out forwards;
    border-radius: 4px;
}

@keyframes load {
    0% {
        width: 0%;
    }

    100% {
        width: 100%;
    }
}

.logo-container {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.logo-container img {
    width: 300px;
    height: auto;
    position: relative;
    z-index: 2;
    margin-bottom: 30px;
}
</style>
